module.exports = __webpack_public_path__ + "static/img/login-logo.f13a49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-logo.png
// module id = nkOi
// module chunks = 1